// Признак «слайды про единый профиль уже показаны».
//
// ЧЕСТНО ПРО ХРАНИЛИЩЕ. Правильное место для этого признака — профиль на
// сервере: тогда человек, прошедший мастер на телефоне, не увидит слайды снова
// на ноутбуке. Поля под это в контракте `profile` нет (`onboardingState` знает
// только пять шагов мастера), а сервер в этой фазе закрыт для правок, поэтому
// признак живёт в `localStorage` браузера. Следствие, которое надо понимать:
//
//   • другой браузер / приватное окно / очистка данных → слайды покажутся ещё раз;
//   • ничего, кроме трёх экранов текста, за этим флагом не стоит: ни доступа,
//     ни начислений, ни согласий — поэтому повтор безвреден, а не опасен.
//
// Заменяется одним полем в профиле (`profile.onboardingState.introShownAt`) —
// строка выписана в отчёт фазы 2 и в реестр незакрытого.

const KEY = "iec-id.onboarding.intro-seen";

export function hasSeenIntro(): boolean {
	try {
		return localStorage.getItem(KEY) === "1";
	} catch {
		// Приватный режим Safari отвечает отказом на первое же обращение.
		// Тогда слайды просто покажутся — это лучше, чем упасть на них.
		return false;
	}
}

export function markIntroSeen(): void {
	try {
		localStorage.setItem(KEY, "1");
	} catch {
		// см. hasSeenIntro
	}
}
